import React from 'react'
import { Project, PermissionReducer, ModuleReducer, RoleReducer } from '@leverege/api-redux'
import { List, Content, Flex, Checkbox, Label, Pane, Button, Text, TabPane } from '@leverege/ui-elements'
import { ValuesCache } from '@leverege/value-cache'
import { connect } from 'react-redux'
import RoleItem from './RoleItem'
import { filterAndGroupPermissions, groupPermissions, filterAndGroupRoles } from './Util'
import RolePermissionList from './RolePermissionList'
import GroupPermissionList from './GroupPermissionList'
import FilterInput from './FilterInput'

import S from './EditPermissions.css'

function AddAll( { item, onEvent } ) {
  return ( 
    <Button title="Add all permissions in group" variant="link" eventData={item} onClick={onEvent}><i className="fa fa-plus"/></Button>
  )
}

function RemoveAll( { item, onEvent } ) {
  return ( 
    <Button title="Remove all permissions in group" variant="link" eventData={item} onClick={onEvent}><i className="fa fa-minus"/></Button>
  )
}

class SelectPermissions extends React.Component {

  constructor( props ) {
    super( props )
    this.cache = new ValuesCache()    
    this.state = { 
      tab : 'permissions',
      permissions : props,
      selected : { },
      currentModel : null, 
      filter : { inCustom : true, inProject : true, inImagine : false, search : null }
    }
    this.selector = new List.SingleSelector( this, 'selection', { idKey : 'id' } )
  }

  static getDerivedStateFromProps( props, state ) {
    const { permissions } = props
    if ( permissions != state.permissions ) {
      const selected = { }
      permissions.forEach( ( p ) => { selected[p.id] = p } )
      return { permissions, selected }
    }
    return null
  }

  onTabClicked = ( evt ) => {
    this.setState( { tab : evt.value } )
  }

  onFilter = ( event ) => {
    this.setState( { [event.data] : event.value } )
  }

  onSelect = ( evt ) => {
    const { onChange, eventData } = this.props
    const s = { ...this.state.selected }
    const id = evt.data.id
    if ( evt.value === false ) {
      delete s[id]
    } else {
      s[id] = evt.data
    }
    this.setState( { selected : s } )
    onChange( { value : s, data : eventData } )
  }
  
  onAddAllInRole = ( event ) => {
    const { onChange, eventData } = this.props
    const s = { ...this.state.selected }
    event.data.permissions.forEach( ( p ) => {
      s[p.id] = p
    } )
    this.setState( { selected : s } )
    onChange( { value : s, data : eventData } )
  }

  onAddAllInGroup = ( event ) => {
    const { onChange, eventData } = this.props
    const s = { ...this.state.selected }
    event.data.permissions.forEach( ( p ) => {
      s[p.permission.id] = p.permission
    } )
    this.setState( { selected : s } )
    onChange( { value : s, data : eventData } )
  }

  onRemoveAllInGroup = ( event ) => {
    const { onChange, eventData } = this.props
    const s = { ...this.state.selected }
    event.data.permissions.forEach( ( p ) => {
      delete s[p.permission.id]
    } )
    this.setState( { selected : s } )
    onChange( { value : s, data : eventData } )

  }

  render() {
    const { permissions, pPermissions, iPermissions, modules, iRoles, pRoles } = this.props
    const { selected, filter, tab } = this.state
    const roles = this.cache.calc( 'roles', filterAndGroupRoles, pRoles, iRoles, filter )
    const groups = this.cache.calc( 'perms', filterAndGroupPermissions, modules, pPermissions, iPermissions, filter )
    const selectedPermissions = groupPermissions( Object.values( selected ), modules, true )

    return (
      <Pane className={S.content} >
        <Content horizontal>
          <Content.Area>
            <Content>
              <Content.Header>
                <FilterInput value={filter} eventData="filter" onChange={this.onFilter} />
                <TabPane activeTab={tab} onTabClicked={this.onTabClicked}>
                  <TabPane.Tab tabName="Permissions" tabId="permissions"/>                
                  <TabPane.Tab tabName="Role" tabId="roles"/>                
                </TabPane>
              </Content.Header>
              <Content.Area>
                { tab === 'permissions' && (
                  <GroupPermissionList 
                    groups={groups} 
                    selected={selected} 
                    headerOptions={AddAll} 
                    onEvent={this.onAddAllInGroup}
                    onSelect={this.onSelect} />
                ) }  
                { tab === 'roles' && (
                  <RolePermissionList 
                    roles={roles} 
                    headerOptions={AddAll} 
                    onEvent={this.onAddAllInRole} />
                ) }        
               
              </Content.Area>
            </Content>
          </Content.Area>
          <Content.Footer className={S.current}>
            <Content className={S.currentSection}>
              <Content.Header variant="listHeader">
                <Text variant="dialogTitle">Selected Permissions</Text>
              </Content.Header>
              <Content.Area>
                <GroupPermissionList 
                  headerOptions={RemoveAll} 
                  onEvent={this.onRemoveAllInGroup}
                  groups={selectedPermissions} 
                  selected={selected} 
                  onSelect={this.onSelect} />
              </Content.Area>
            </Content>
          </Content.Footer>
        </Content>
      </Pane>
    )
  }
}

export default connect(
  ( state, props ) => {
    return {
      // state,
      pRoles : RoleReducer.getRoles( state.roles, props.role.projectId ),
      iRoles : RoleReducer.getRoles( state.roles, 'imagine' ),

      pPermissions : PermissionReducer.getPermissions( state.permissions, props.role.projectId ),
      iPermissions : PermissionReducer.getPermissions( state.permissions, 'imagine' ),
      status : PermissionReducer.getStatus( state.permissions, props.role.projectId ),
      error : PermissionReducer.getError( state.permissions, props.role.projectId ),
      modules : state.modules,
    }
  }
)( SelectPermissions )
